import { Weddings } from '@bridebook/models';
import { appError } from '@bridebook/web/lib/app/actions';
import type { IEpicDeps } from '@bridebook/web/lib/types';
import {
  IUpdatePublishedPrimaryVenueSupplierAction,
  WeddingActionTypes,
} from '@bridebook/web/lib/weddings/action-types';
import { getWeddingId } from '@bridebook/web/lib/weddings/selectors';
import { ofType } from 'redux-observable';
import { from, Observable, of } from 'rxjs';
import { catchError, mergeMap, withLatestFrom } from 'rxjs/operators';
import { isVenueSection } from '@bridebook/web/lib/wedding-website/utils/sections-typeguards';

export const updatePublishedWebsiteSectionsEpic = (
  action$: Observable<IUpdatePublishedPrimaryVenueSupplierAction>,
  { state$ }: IEpicDeps,
) =>
  action$.pipe(
    ofType(WeddingActionTypes.WEBSITE_UPDATE_PUBLISHED_PRIMARY_VENUE_SUPPLIER),
    withLatestFrom(state$),
    mergeMap(([action, state]) => {
      const weddingId = getWeddingId(state);
      const { supplier } = action.payload;

      if (!weddingId) {
        return of();
      }

      return from(Weddings._.getById(weddingId).get()).pipe(
        mergeMap((wedding) => {
          const website = wedding?.website;
          if (!website?.sections) {
            return of();
          }

          const updatedSections = website.sections.map((section) => {
            if (isVenueSection(section)) {
              return {
                ...section,
                data: {
                  ...section.data,
                  supplier,
                },
              };
            }
            return section;
          });

          return from(
            Weddings._.getById(weddingId).set({ website: { sections: updatedSections } }, true),
          ).pipe(mergeMap(() => of()));
        }),
        catchError((error: Error) =>
          of(appError({ error, feature: 'Updating published website sections' })),
        ),
      );
    }),
    catchError((error: Error) =>
      of(appError({ error, feature: 'Updating published website sections' })),
    ),
  );
